import React from 'react';
import useBlog from './../../hooks/useBlog';
import BlogCard from '../../components/BlogCard';
import BlogSlider from '../../components/BlogSlider';
import { Helmet } from 'react-helmet';

function Blog() {
  const { allBlogs, totalCount } = useBlog();

  const blogs = allBlogs.filter((blog) => blog.category === 'blog');
  const news = allBlogs.filter((blog) => blog.category === 'news');

  return (
    <div style={{ marginBottom: '8rem' }}>
      <Helmet>
        <title>Blog/News | Solaric</title>
      </Helmet>
      <div className='container'>
        <div className='row header-title text-center'>
          <div className='col-md-8 col-lg-6 mx-auto'>
            <h2>Blog/News</h2>
            {/* <h4>Know the Latest News of Solaric</h4> */}
          </div>
        </div>
        <BlogSlider />
        <div className='row blog-container'>
          <div>
            <div className='title'>
              <h2>News</h2>
            </div>
            <div className='blogs'>
              {news?.map((blog, idx) => (
                <BlogCard key={idx} blog={blog} />
              ))}
            </div>
          </div>
          <div className='my-5'>
            <div className='title'>
              <h2>Blog Posts</h2>
            </div>
            <div className='blogs'>
              {blogs?.map((blog, idx) => (
                <BlogCard key={idx} blog={blog} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blog;
